<template>
  <div v-if="!navItem.hasChildren">
    <v-list-item :to="navItem.to" link exact>
      <v-list-item-action>
        <v-icon>{{ navItem.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ $t(navItem.title) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </div>
  <div v-else-if="navItem.children">
    <v-list-group :prepend-icon="navItem.icon" no-action>
      <template v-slot:activator>
        <v-list-item-title>{{ $t(navItem.title) }}</v-list-item-title>
      </template>
      <template v-for="(subMenuItem, id) in navItem.children">
        <v-list-item :key="id" :to="subMenuItem.to" link exact>
          <v-list-item-content>
            <v-list-item-title>{{ $t(subMenuItem.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-group>
  </div>
</template>

<script>

export default {
  props: {
    navItem: {},
  },
  methods: {
  },
  computed: {
  },
}
</script>